import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import AgendaView from '../../moreCore/UI/AgendaView/AgendaView';
import "../../moreCore/UI/AgendaView/AgendaView";
import FilterPanelWidget from '../../moreCore/UI/FilterPanel/FilterPanel';
import "../../moreCore/UI/FilterPanel/FilterPanel";
import template from './_template.html?raw';
import templateDPtl from './_template_DPtl.html?raw';
import templateDPt from './_template_DPt.html?raw';
import templateDPfw from './_template_DPfw.html?raw';
import templateDP23 from './_template_DP23.html?raw';
import "../AgendaViewBase/AgendaViewBaseTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';

import { FilterPanelTypes, FilterPanelFormat, FilterOptionTypes } from "../../moreCore/UI/FilterPanel/FilterPanelTypes";
import { FinderTypes } from "../FinderBase/FinderBaseTypes";
import { AgendaViewTypes } from "../AgendaViewBase/AgendaViewBaseTypes";
import { ToasterHelpers } from "../../more/Helpers";
import Button from '../../moreCore/UI/Button/Button';
import "../../moreCore/UI/Button/Button";

//import FilterPanelOption = require("../../moreCore/UI/FilterPanel/FilterPanelOption"); WOZU?

type AgendaviewLayout = "default" | "datepickerFullwidth" | "datepickerTwoThird" | "datepickerTopLeft" | "datepickerTop";


class AgendaViewBase<T> extends compose(_WidgetBaseSP) {
    templateString: any = template;

    agendaView: MdsLax<InstanceType<typeof AgendaView<T>>>;

    private loadFilterDataUrl: string = null;
    protected loadFilterOptionsUrl: string = undefined;
    private loadFilterOptionsFct: string = undefined;
    private loadFilterDataFct: string = null;
    private rowClickFunction: StaticTable.rowclickCallback;
    private dateChangeCallbackCustom: AgendaViewTypes.dateSelectCallback;

    protected _timeout: number = null;
    private _loadRequest: any = null;
    private __dojoStartupDone: boolean = false;

    private requestParams: Array<{ name: string, value: any }> = null;
    private requestData: Object = null;


    filterpanel: MdsLax<InstanceType<typeof FilterPanelWidget>>;
    //protected sectionFilter: HTMLDivElement;

    private _currentFilterSettings;
    private _currentFilterSettingsApplied;
    private formatterFunction: Function;
    private formatterFunctionHeadings: StaticTable.headingFormatterCallback;

    private currentMonthDate: Date;
    private visibleStart: Date;
    private visibleEnd: Date;
    public selectedStart: Date;
    public selectedEnd: Date;
    private heading: HTMLElement;

    private earliestDate: Date = null;
    private latestDate: Date = null;

    //private dateStartTxt: string;
    //private dateEndTxt: string;

    private _layouts: Array<StaticTable.Layout> = null;
    internalName: string;

    protected sectionTop: HTMLElement;
    protected sectionBottom: HTMLElement;
    private _hiddenContainer: HTMLElement;
    private tableContainer: HTMLElement;
    private datepickerContainer: HTMLElement;
    protected filterpanelContainer: HTMLElement;
    protected btnReloadPage: MdsLax<InstanceType<typeof Button>>;
    protected buttonGroupContainer: HTMLElement;

    protected _standbyText: string = null;

    //private datepickerContainerName: string = null;// "resultContainer";
    //private tableContainerName: string;
    //private filterContainerName: string = null;// "filterPanelContainer";

    protected widgetTemplateVariant: AgendaviewLayout

    constructor(props?: Object) {
        super(...(arguments as unknown as []));

        if (props) {
            lang.mixin(this, props);
        }

        //if (config) {
        //    switch (config.templateVariant) {
        //        case "datepickerTopLeft":
        //        case "datepickerTop":
        //            this.widgetTemplateVariant = config.templateVariant;
        //            break;
        //    }
        //}

        
        if (this.widgetTemplateVariant) {
            switch (this.widgetTemplateVariant) {
                case "datepickerTopLeft":
                    this.templateString = templateDPtl;
                    break;
                case "datepickerFullwidth":
                    this.templateString = templateDPfw;
                    break;
                case "datepickerTwoThird":
                    this.templateString = templateDP23;
                    break;

                case "datepickerTop":
                    this.templateString = templateDPt;
                    break;
            }
        }
    }


    private loadFilterOptions(): void {
        if (this.loadFilterDataFct == undefined && this.loadFilterDataUrl == undefined) return;

        if (!this.loadFilterOptionsUrl && !this.loadFilterOptionsFct) {
            this.createAgendaViewWithoutFilterpanel();
            return;
        }
        this.hourGlassStart();



        if (this.loadFilterOptionsFct) {
            this.RequestManager.callfunction(
                this.loadFilterOptionsFct,
                this._createRequestData().jsonData,
                lang.hitch(this, this._onLoadFilterOptionsResponse),
                lang.hitch(this, this._onLoadFilterOptionsError),
            );

        } else {

            var url = window.appRoot + this.loadFilterOptionsUrl;

            this.RequestManager.post(
                url,
                this._createRequestData(),
                lang.hitch(this, this._onLoadFilterOptionsResponse),
                lang.hitch(this, this._onLoadFilterOptionsError),
                false // sync
            );
        }
    }

    private _onLoadFilterOptionsResponse(response: FinderTypes.AgendaViewOptions) {

        ToasterHelpers.removeToast("filteroptions");

        if (response.tableLayouts) {
            this._layouts = response.tableLayouts;
        }

        this.hourGlassEnd();


        if (response.earliestDate) {
            let earliestDate: string | Date = response.earliestDate;
            if (typeof (response.earliestDate) == "string") {
                try {
                    earliestDate = new Date(response.earliestDate);
                } catch (ex) {


                }
            }
            this.earliestDate = earliestDate;
        }
        if (response.latestDate) {
            let latestDate: string | Date = response.latestDate;
            if (typeof (response.latestDate) == "string") {
                try {
                    latestDate = new Date(response.latestDate);
                } catch (ex) {


                }
            }
            this.latestDate = latestDate;
        }


        if (response.sections && response.sections.length) {
            if (this.createAgendaView() == true) {
                this.prepareFilteroptions(response);
            }
        } else {
            this.createAgendaViewWithoutFilterpanel();
        }

        if (this._initialDateValue) {
            let initialDate = new Date(this._initialDateValue);
            this.agendaView.setDate(initialDate);
            this._initialDateValue = null;
        }
    }

    private _onLoadFilterOptionsError(error: more.requestErrorMessage) {

        this.hourGlassEnd();

        alert(this.translate("Error__OptionsCantBeLoaded") + error.Message);
        console.log(this.translate("Error__OptionsCantBeLoaded") + error.Message);

        ToasterHelpers.showToast({
            title: "Error__OptionsCantBeLoaded",
            iconClass: ToasterHelpers.ToasterIcons.error,
            showClose: true,
            message: error.Message,
            ID: "filteroptions",
            timeout: "permanent"
        });
    }

    private _showErrorDlg(heading: string, message: string) {
        let dlg = new GenericDialog();
        dlg.show(message, heading, null, "fas fa-times-circle w3-text-red", "ok");
    }

    private prepareFilteroptions(data: FinderTypes.AgendaViewOptions) {

        let fpContainer = this.filterpanelContainer; // this.filterContainerName ? this[this.filterContainerName] ? this[this.filterContainerName] : this.filterpanelContainer : this.filterpanelContainer;

        if (fpContainer) {
            this.UiModder.domConstruct.empty(fpContainer);
        } else {
            alert(this.id + ": filterpanelContainer not defined");
            return;
        }


        if (data.sections) {
            let fp = new FilterPanelWidget();
            this.filterpanel = fp;
            fp.placeAt(fpContainer);

            fp.outputFormat = FilterPanelFormat.compact; // das Format lassen wir jetzt mal fix. data.format == "compact" ? "compact" : "default";

            fp.setSectionData(data.sections);

            this.filterpanel.on("serializedData", lang.hitch(this, this._onFilterpanelChange));

            this.filterpanel.serializeData();
        } else {

        }
        // falls man noch was ergänzen möchte (readonly z.B.)
        //this.filterOptions_additionalConfig();
    }

    private _onFilterpanelChange(resultData: any): void {
        // bestehendes Event unterbrechen
        if (this._timeout != null) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }

        this._timeout = setTimeout(lang.hitch(this, this.checkFilterPanelData), 500);
    }

    private checkFilterPanelData(bForceIfNotDirty: boolean): void {

        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }

        if (!this.filterpanel) return;

        let json = { sections: this.filterpanel.getData() };
        let bValid = json.sections !== null;

        this._currentFilterSettings = json;
        if ((bForceIfNotDirty === true || JSON.stringify(this._currentFilterSettingsApplied) != JSON.stringify(this._currentFilterSettings)) &&
            bValid === true) {
            this.loadDataDelayed(this.selectedStart);
        }
    }

    protected setHeading(text: string) {
        this.UiModder.domAttr.set(this.heading, "innerHTML", text);

        if (text) {
            this.hideNode(this.heading, false);
        } else {
            this.hideNode(this.heading, true);
        }
    }


    private createAgendaViewWithoutFilterpanel() {
        //alert("No URL for loadFilterOptions specified!");
        //if (!this._layouts) {
        //    alert(this.id + ": Agendaview needs table layouts!");
        //    return;
        //}
        this.hideNode(this.filterpanelContainer);
        if (this.createAgendaView() == true) {
            this.agendaView.setConfig(this.currentMonthDate);
        }
    }

    protected _onAgendaViewConfigSet(agendaview: MdsLax<InstanceType<typeof AgendaView>>) {
        // override this
    }

    protected _agendaViewConfigSet() {
        //console.log("_agendaViewConfigSet");
        this._onAgendaViewConfigSet(this.agendaView);
    }

    private _initialDateValue: number;
    private _initialGotoDateValue: number;

    protected createAgendaView(): boolean {
        this.disableNode(this.domNode);


        this.agendaView = new AgendaView();
        
        this.agendaView.setDateLimits(this.earliestDate, this.latestDate);
        let targetNode = this._hiddenContainer;// this[this.datepickerContainerName] as HTMLElement;
        if (this._hiddenContainer) {
            this.agendaView.placeAt(targetNode, "only");
        }


        let datepickerNode = this.datepickerContainer;// this.datepickerContainerName ? this[this.datepickerContainerName] : this.datepickerContainer;
        if (datepickerNode) {
            this.agendaView.datePicker.placeAt(datepickerNode, "only");
            this.hideNode(datepickerNode, false);
        } else {
            alert(this.id + ": no datepickernode defined");
        }

        let tableNode = this.tableContainer;// this.tableContainerName ? this[this.tableContainerName] : this.tableContainer;
        if (tableNode) {
            this.agendaView.resultTable.placeAt(tableNode, "only");

        } else {
            alert(this.id + ": no tablenode defined");
        }


        this.agendaView.setConfig({
            navigationDate: this.currentMonthDate,
            layouts: this._layouts,
            tablerowExpanderConfig: this.config.tableRowExpanderConfig,
            showAppointmentLabels: this.config?.showAppointmentLabels == true,
        });

        if (!this._layouts?.length) {
            alert(this.id + ": no tablelayouts available. check config or API!");
            return false;
        }


        this.agendaView.on("configSet", lang.hitch(this, this._agendaViewConfigSet));
        this.agendaView.on("dateChanged", lang.hitch(this, this.dateChanged_callback))
        this.agendaView.on("monthChanged", lang.hitch(this, this.monthChanged_callback))

        if (this.dateChangeCallbackCustom) this.agendaView.setDateSelectCallback(this.dateChangeCallbackCustom);

        if (this.internalName) this.agendaView.internalName = this.internalName;

        let button = this.agendaView.resultTable.getLayoutSelectorButton();
        if (button && this.buttonGroupContainer) {
            button.placeAt(this.buttonGroupContainer, "first");
        }

        this.agendaView.setFormatter(this.formatterFunction, this.formatterFunctionHeadings);

        if (this.rowClickFunction) {
            this.agendaView.setRowClick(lang.hitch(this, this.rowClickFunction))
        } else {
            this.agendaView.setRowClick(null);
        }

        this.disableNode(this.domNode, false);
        return true;
    }

    private _onClick_Reload(evt: MouseEvent) {
        this._reload();
    }

    private _reload(): void {
        this.loadData(this.selectedStart);

        this.onReloadData();
    }

    reload(): void {
        this._reload();
    }

    protected redrawTable() {
        if (this._loadRequest) return;
        if (!this.agendaView) return;
        this.agendaView.redrawTable();
    }

    private _loadTimeout: any = null;
    loadDataDelayed(targetDate?: Date, delay: number = 900) {
        if (!delay || delay < 0) delay = 900;

        if (this._loadTimeout) clearTimeout(this._loadTimeout);

        this.disableNode(this.tableContainer);

        if (this._loadRequest && this._loadRequest.cancel) {
            this._loadRequest.cancel();

        }

        this._loadTimeout = setTimeout(lang.hitch(this, this.loadData, targetDate), delay);
    }

    protected onLoadData() {
        // wird von Kindklasse überschrieben
    }
    protected onReloadData() {
        // wird von Kindklasse überschrieben
    }
    protected onLoadedData() {
        // wird von Kindklasse überschrieben
    }

    loadData(targetDate?: Date) {

        if (this._loadTimeout) clearTimeout(this._loadTimeout);

        if (this.filterpanel && !this._currentFilterSettings) {
            this.StandbyStop("dataload");
            return;
        }

        this.onLoadData();

        this.visibleStart = this.agendaView.getExtendedStartDate(); //new Date(selectedMonth.getFullYear(), selectedMonth.getMonth(), 1, 0, 0, 0, 0);//.toISOString();//.substring(0, 10);
        this.visibleEnd = this.agendaView.getExtendedEndDate(); // new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, 1, 0, 0, 0);//.toISOString();//.substring(0, 10);

        if (!this.visibleStart || !this.visibleEnd) return;

        if (targetDate && targetDate.valueOf) {
            if (targetDate.valueOf() < this.visibleStart.valueOf() ||
                targetDate.valueOf() > this.visibleEnd.valueOf()) {
                this.agendaView.setDate(targetDate);
                return;
            }
        }
        if (this._standbyText) this.StandbyStartWithText(this._standbyText, this.datepickerContainer,"dataload");
        else this.StandbyStart(this.datepickerContainer, "dataload");

        this.disableNode(this.tableContainer);
        this.btnReloadPage.setReadonly(true);

        let data = {
            filterOptions: this._currentFilterSettings,
            dateStart: this.dateToLocalISOString(this.visibleStart),
            dateEnd: this.dateToLocalISOString(this.visibleEnd),
            /*selectedDate: this.*/
        };

        let requestData = this._createRequestData(data);

        //console.debug(this.id + " requestData", requestData);

        if (this._loadRequest && this._loadRequest.cancel) this._loadRequest.cancel();

        if (this.loadFilterDataFct) {

            this._loadRequest = this.RequestManager.callfunction(
                this.loadFilterDataFct,
                requestData.jsonData,
                lang.hitch(this, this._onLoadResultListResponse, targetDate),
                lang.hitch(this, this._onLoadResultListError),
            );

        } else {

            let url = window.appRoot + this.loadFilterDataUrl;

            this._loadRequest = this.RequestManager.post(
                url,
                requestData,
                lang.hitch(this, this._onLoadResultListResponse, targetDate),
                lang.hitch(this, this._onLoadResultListError),
                false // sync
            );
        }
    }

    private monthChanged_callback(selectedMonth: Date) {

        if (selectedMonth) {
            let txt = selectedMonth.toString();
            let cleanDate = new Date(txt);

            this.selectedStart = null;
            this.selectedEnd = null;

            this.currentMonthDate = selectedMonth;
            //this.visibleEnd.setSeconds(this.visibleEnd.getSeconds() - 1); // eine Sekunde abziehen#
            if (this.filterpanel) {
                if (!this.filterpanel.valid) {
                    return;
                }
            }
            this.loadDataDelayed();
        }
    } private dateChanged_callback(selectedDates: Array<Date>) {

        // Datepicker liefert hier ein Array. In der Agendaview wird aber immer nur eines oder keines verwendet, also length <= 1
        let selectedDate: Date = null;
        if (selectedDates && selectedDates.length) {
            selectedDate = selectedDates[0];

            this.selectedStart = selectedDates[0];
            this.selectedEnd = selectedDates[selectedDates.length - 1];
        } else {
            this.selectedStart = null;
            this.selectedEnd = null;
        }


        if (selectedDate != null) {
            // es wurde ein einzelnes spezifisches Datum gewählt
            // Achtung: der restliche Monat muss trotzdem auch ans Backend geschickt werden
            this.visibleStart = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());//.toISOString().substring(0, 10);
            this.visibleEnd = this.visibleStart;// new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1).toISOString().substring(0, 10);

            /*this.getData();*/
        } else {
            // kein Datum gewählt bzw. Datum abgewählt
            // dann vom vorherigen gewählten Datum den ganzen Monat verwenden
            //    this.monthChanged_callback(this.currentMonthDate)
            //    return;
        }

        if (this.dateChangeCallbackCustom) this.dateChangeCallbackCustom(selectedDates);
    }

    private _onLoadResultListResponse(targetDate: Date, response: AgendaViewTypes.ViewbaseResult<any>) {
        this._loadRequest = null;

        ToasterHelpers.removeToast("filterdataError");

        this.btnReloadPage.setReadonly(false),
            this.disableNode(this.tableContainer, false);
        this.hideNode(this.tableContainer, false);
        this.disableNode(this.datepickerContainer, false);

        this.agendaView.setEntries(response.agendaviewEntries, response.holidays);

        if (targetDate) {
            this.agendaView.setDate(targetDate);
        } else {
            this.selectedStart = null;
            this.selectedEnd = null;
            this.agendaView.setDate(null);
        }

        this.StandbyStop("dataload");

        this._currentFilterSettingsApplied = this._currentFilterSettings;

        this.onLoadedData();
    }

    private _onLoadResultListError(err: more.requestErrorMessage) {

        this.StandbyStop("dataload");
        this.disableNode(this.datepickerContainer, false);
        this.disableNode(this.tableContainer, false);
        this.btnReloadPage.setReadonly(false),

            ToasterHelpers.showToast({
                title: "error loading results",
                message: err.Message,
                iconClass: ToasterHelpers.ToasterIcons.error,
                ID: "filterdataError",
                timeout: "permanent"
            });
    }

    setStandbyLoadingTexts(dataloadingText: string) {
        if (dataloadingText) this._standbyText = dataloadingText;
        else this._standbyText = null;
    }

    private config: AgendaViewTypes.AgendaviewSetupConfig;

    /**
     * Konfiguriert eine Agendaview mitsamt Ergebnisliste und optional Filterpanel (à la FinderBaseV2)
     * @param configCallfunction Callfunction-Name für den Abruf des Filterpanels (API, muss auf Whitelist freigeschaltet sein; kann null sein)
     * @param filterdataCallfunction Callfunction-Name für das Laden der Ergebnisse (API, muss auf Whitelist freigeschaltet sein)
     * @param rowClickFunction Callback bei Klicken eines Entities in der Tabelle
     * @param tableFormatterFunction Formatierungs-Funktionen für die Tabellenzellen
     * @param tableLayouts Nötig, falls die Agendaview ohne Filterconfig-Callfunction ausgeführt wird. Wenn leer: Tabelle wird nicht geladen.
     * @param dateSelectCallback Optional: Callback, das beim Wechseln (Wählen/Abwählen) eines Datums aufgerufen wird.
     * @param additionalRequestData Zusätzliche Parameter im Request (wird zu jsonData eingefügt, oder als separater Wert wenn setAsNewParameter true)
    * @deprecated normales setup mit config verwenden
     * */
    setupAgendaViewWithCallfunction(config: AgendaViewTypes.AgendaviewSetupConfig
    )
    /**
     * Konfiguriert eine Agendaview mitsamt Ergebnisliste und optional Filterpanel (à la FinderBaseV2)
     * @param configCallfunction Callfunction-Name für den Abruf des Filterpanels (API, muss auf Whitelist freigeschaltet sein; kann null sein)
     * @param filterdataCallfunction Callfunction-Name für das Laden der Ergebnisse (API, muss auf Whitelist freigeschaltet sein)
     * @param rowClickFunction Callback bei Klicken eines Entities in der Tabelle
     * @param tableFormatterFunction Formatierungs-Funktionen für die Tabellenzellen
     * @param tableLayouts Nötig, falls die Agendaview ohne Filterconfig-Callfunction ausgeführt wird. Wenn leer: Tabelle wird nicht geladen.
     * @param dateSelectCallback Optional: Callback, das beim Wechseln (Wählen/Abwählen) eines Datums aufgerufen wird.
     * @param additionalRequestData Zusätzliche Parameter im Request (wird zu jsonData eingefügt, oder als separater Wert wenn setAsNewParameter true)
     * @deprecated normales setup mit config verwenden
     * */
    setupAgendaViewWithCallfunction(configCallfunction: string,
        filterdataCallfunction: string,
        rowClickFunction: StaticTable.rowclickCallback,
        tableFormatterFunction: Function,
        tableLayouts?: Array<StaticTable.Layout>,
        dateSelectCallback?: Function,
        earliestDate?: Date,
        latestDate?: Date,
        additionalRequestData?: Array<{ name: string, value: any, setAsNewParameter?: boolean }>
    )
    /**
     * Konfiguriert eine Agendaview mitsamt Ergebnisliste und optional Filterpanel (à la FinderBaseV2)
     * @param configCallfunction Callfunction-Name für den Abruf des Filterpanels (API, muss auf Whitelist freigeschaltet sein; kann null sein)
     * @param filterdataCallfunction Callfunction-Name für das Laden der Ergebnisse (API, muss auf Whitelist freigeschaltet sein)
     * @param rowClickFunction Callback bei Klicken eines Entities in der Tabelle
     * @param tableFormatterFunction Formatierungs-Funktionen für die Tabellenzellen
     * @param tableLayouts Nötig, falls die Agendaview ohne Filterconfig-Callfunction ausgeführt wird. Wenn leer: Tabelle wird nicht geladen.
     * @param dateSelectCallback Optional: Callback, das beim Wechseln (Wählen/Abwählen) eines Datums aufgerufen wird.
     * @param additionalRequestData Zusätzliche Parameter im Request (wird zu jsonData eingefügt, oder als separater Wert wenn setAsNewParameter true)
    * @deprecated normales setup mit config verwenden
    * */
    setupAgendaViewWithCallfunction(configCallfunction: string | AgendaViewTypes.AgendaviewSetupConfig,
        filterdataCallfunction?: string,
        rowClickFunction?: StaticTable.rowclickCallback,
        tableFormatterFunction?: StaticTable.formatterCallback,
        tableLayouts?: Array<StaticTable.Layout>,
        dateSelectCallback?: AgendaViewTypes.dateSelectCallback,
        earliestDate?: Date,
        latestDate?: Date,
        additionalRequestData?: Array<{ name: string, value: any, setAsNewParameter?: boolean }>
    ): void {

        if (typeof (configCallfunction) == "string") {
            this.setupAgendaView({
                filterdataUrl: null,
                configUrl: null,
                configCallfunction: configCallfunction,
                filterdataCallfunction: filterdataCallfunction,
                rowClickFunction: rowClickFunction,
                tableFormatterFunction: tableFormatterFunction,
                tableRowExpanderConfig: null,
                additionalRequestData: additionalRequestData,
                dateSelectCallback: dateSelectCallback,
                earliestDate: earliestDate,
                latestDate: latestDate,
                tableLayouts: tableLayouts
            });
        } else {
            this.setupAgendaView(configCallfunction);
        }
    }
    /**
     * Konfiguriert eine Agendaview mitsamt Ergebnisliste und optional Filterpanel (à la FinderBaseV2)
     */
    setupAgendaView(config: AgendaViewTypes.AgendaviewSetupConfig)
    /**
     * Konfiguriert eine Agendaview mitsamt Ergebnisliste und optional Filterpanel (à la FinderBaseV2)
     * @param filteroptionsUrl Kann leer sein, falls kein Filterpanel geladen werden soll. Unbedingt tableLayouts ausfüllen!!
     * @param filterdataUrl URL zum Laden der Daten nach Filterung bzw. Umschalten des Datums
     * @param rowClickFunction Callback bei Klicken eines Entities in der Tabelle
     * @param tableFormatterFunction Formatierungs-Funktionen für die Tabellenzellen
     * @param tableLayouts Nötig, falls die Agendaview ohne Filteroptions-URL ausgeführt wird. Wenn leer: Tabelle wird nicht geladen.
     * @param dateSelectCallback Optional: Callback, das beim Wechseln (Wählen/Abwählen) eines Datums aufgerufen wird.
     * @param additionalRequestData Zusätzliche Parameter im Request (wird zu jsonData eingefügt, oder als separater Wert wenn setAsNewParameter true)
     * @deprecated Nicht mehr verwenden. Aufruf mit Config-Objekt verwenden.
     */
    setupAgendaView(filteroptionsUrl: string,
        filterdataUrl: string,
        rowClickFunction: StaticTable.rowclickCallback,
        tableFormatterFunction: Function,
        tableLayouts?: Array<StaticTable.Layout>,
        dateSelectCallback?: Function,
        earliestDate?: Date,
        latestDate?: Date,
        additionalRequestData?: Array<{ name: string, value: any, setAsNewParameter?: boolean }>
    )
    /**
 
     */
    setupAgendaView(filteroptionsUrlOrConfig: string | AgendaViewTypes.AgendaviewSetupConfig,
        filterUrl?,
        rowClick?,
        formatter?,
        layouts?,
        dateSelect?,
        earliest?,
        latest?,
        additionalReq?
    ) {
        //this._layouts = this.tableLayouts_Bookings;

        

        let config = filteroptionsUrlOrConfig as AgendaViewTypes.AgendaviewSetupConfig;
        // parameter 1 und 2 könnten null sein (weil das früher filteroption-urls waren)
        if (!config || typeof (filteroptionsUrlOrConfig) == "string" ||!!rowClick || !!layouts) {

            // dann davon ausgehen, dass wir im legacy-mode unterwegs sind
            // aus den Parametern eine config bauen:
            config = {
                configUrl: filteroptionsUrlOrConfig as string,
                filterdataUrl: filterUrl,
                configCallfunction: null,
                filterdataCallfunction: null,
                rowClickFunction: rowClick,
                tableFormatterFunction: formatter,
                tableLayouts: layouts,
                tableRowExpanderConfig: null,
                dateSelectCallback: dateSelect,
                earliestDate: earliest,
                latestDate: latest,
                additionalRequestData: additionalReq
            }
        }

        if (!config) return;

        this.config = config;

        this.loadFilterOptionsFct = config.configCallfunction;
        this.loadFilterDataFct = config.filterdataCallfunction;


        this.loadFilterOptionsUrl = config.configUrl;
        this.loadFilterDataUrl = config.filterdataUrl;


        this.rowClickFunction = config.rowClickFunction;

        if (config.tableFormatterFunction) {
            this.formatterFunction = config.tableFormatterFunction;
        }

        if (config.tableHeaderFormatterFunction) this.setTableHeadingFormatter(config.tableHeaderFormatterFunction);

        if (config.earliestDate) this.earliestDate = config.earliestDate;
        if (config.latestDate) this.latestDate = config.latestDate;

        if (config.dateSelectCallback) this.dateChangeCallbackCustom = config.dateSelectCallback;

        if (config.initialSelectedDate) {
            this._initialDateValue = config.initialSelectedDate.valueOf();
        }

        this.requestParams = [];
        if (config.additionalRequestData && config.additionalRequestData.length) {
            this.requestData = {};
            for (let param of config.additionalRequestData) {
                if (param.setAsNewParameter === true) {
                    this.requestParams.push({ name: param.name, value: param.value });
                } else {
                    this.requestData[param.name] = param.value;
                }
            }
        }

        if (config.tableLayouts) {
            if (lang.isArray(config.tableLayouts)) {
                this._layouts = config.tableLayouts;
            } else {
                this._layouts = [config.tableLayouts];
            }
        }

        if (this.__dojoStartupDone === true) {
            this.loadFilterOptions();
        }

    }

    protected setTableHeadingFormatter(formatter: StaticTable.headingFormatterCallback) {
        this.formatterFunctionHeadings = formatter;
    }

    private _createRequestData(baseData?: Object): { jsonData: string } {


        if (this.requestData != null) {
            if (!baseData) {
                baseData = {};
            }
            baseData = { ...this.requestData, ...baseData };
        }

        let requestData = {
            jsonData: baseData ? JSON.stringify(baseData) : null
        };
        if (this.requestParams.length) {
            for (let param of this.requestParams) {
                requestData[param.name] = JSON.stringify(param.value);
            }
        }

        return requestData;
    }

    setContentInTopSection(content: string | HTMLElement) {
        if (this.sectionTop) {
            this.UiModder.domConstruct.empty(this.sectionTop);

            if (typeof (content) == "string") {
                this.UiModder.domAttr.set(this.sectionTop, "innerHTML", content);
            } else if (!!content && content instanceof HTMLElement) {
                this.UiModder.domConstruct.place(content, this.sectionTop);
            }

            this.hideNode(this.sectionTop, !content);
        }
    }

    setContentInBottomSection(content: string | HTMLElement) {
        if (this.sectionBottom) {
            this.UiModder.domConstruct.empty(this.sectionBottom);

            if (typeof (content) == "string") {
                this.UiModder.domAttr.set(this.sectionBottom, "innerHTML", content);
            } else if (!!content && content instanceof HTMLElement) {
                this.UiModder.domConstruct.place(content, this.sectionBottom);
            }

            this.hideNode(this.sectionBottom, !content);
        }
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        // required for dojo inheritance to call the superclass

        if (!this.__dojoStartupDone) {
            super.startup.apply(this, arguments as any);

            this.loadFilterOptions();

            this.__dojoStartupDone = true;
        }
    }
}

export default mdsWidget(AgendaViewBase);
